
import { createModel } from '@rematch/core'

const initialState: { translationMode:  "DEV" | "PROD"  } = {
   
    translationMode: "PROD", 

}


export const configModel = createModel()({
    state: { ...initialState },
    reducers: {

        setTranslationMode(state, payload) {
            return {
                ...state,
                translationMode: payload,
            }
        },
      
    },
   

})